import { render } from "./App.vue?vue&type=template&id=71f0d650"
const script = {}

import exportComponent from "/builds/kinarya-disnakertransdiy/disnakertrans-diy/padatkarya/pk-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__